// Clients (B2B and B2C pages) — date and number formatting. Dates come from
// the shared short format (utils/dates: parseUtc, Paris time, KI-110).
import { formatRelative as sharedRelative, formatShortDate, formatShortDateTime } from '../utils/dates';

const nbsp = (text) => String(text).replace(/\u202f/g, '\u00a0');

// « 28 oct. » this year, « 28 oct. 2025 » before ('' when empty).
export const formatDay = (value) => formatShortDate(value, undefined, { empty: '' });
export const formatShortDay = (value, now) => formatShortDate(value, undefined, { now, empty: '' });

// « 28 oct., 10:02 » — the year only when it is not this year.
export const formatStamp = (value, now) => formatShortDateTime(value, undefined, { now, empty: '' });

// « il y a 12 min », « il y a 3 h », « hier », then the day.
export const formatRelative = (value, now) => sharedRelative(value, undefined, now, { empty: '' });

export const formatCount = (value) => nbsp(Number(value || 0).toLocaleString('fr-FR'));

// 0.643 → « 64 % »
export const formatPercent = (ratio) => (ratio === null || ratio === undefined || Number.isNaN(ratio)
  ? '—'
  : nbsp(`${Math.round(ratio * 100)} %`));

export const formatMoney = (value, currency = 'EUR') => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '';
  try {
    return nbsp(amount.toLocaleString('fr-FR', { style: 'currency', currency: currency || 'EUR' }));
  } catch (e) {
    return nbsp(`${amount.toLocaleString('fr-FR')} ${currency || ''}`.trim());
  }
};

// URL state helper: set or remove query params in one replace.
export const nextParams = (searchParams, updates) => {
  const next = new URLSearchParams(searchParams);
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') next.delete(key);
    else next.set(key, String(value));
  });
  return next;
};
